import React, { useEffect, useState } from 'react';
import {
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import AdministratorsRolesService from '../../../services/AdministratorsRolesService';
import { useTranslation } from 'react-i18next';
import translateRole from '../../../utils/roleTranslations';

const SystemRoles = () => {
    const { t } = useTranslation();

    useEffect(() => {
        retrieveAdminRoles();
    }, []);

    const [adminRoles, setAdminRoles] = useState([]);

    const retrieveAdminRoles = () => {
        AdministratorsRolesService.getAll()
            .then(response => {
                setAdminRoles(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    };

    // Function to handle checkbox change
    const handleCheckboxChange = (event, rowId, columnId) => {
        // Logic to update the data based on checkbox change
    };

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            {t('systemAdmin.systemRoles.roleType')}
                        </TableCell>
                        <TableCell align="center">
                            {t('systemAdmin.systemRoles.canCreateAll')}
                        </TableCell>
                        <TableCell align="center">
                            {t('systemAdmin.systemRoles.canViewAll')}
                        </TableCell>
                        <TableCell align="center">
                            {t('systemAdmin.systemRoles.canEditAll')}
                        </TableCell>
                        <TableCell align="center">
                            {t('systemAdmin.systemRoles.canDeleteAll')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {adminRoles.map((row, rowIndex) => (
                        <TableRow
                            key={row.id}
                            sx={{
                                '&:last-child td, &:last-child th': {
                                    border: 0,
                                },
                            }}
                        >
                            <TableCell component="th" scope="row">
                                {translateRole(row.role_name, t)}
                            </TableCell>
                            <TableCell align="center" key={`c-${row.id}`}>
                                <Checkbox checked={row.c} />
                            </TableCell>
                            <TableCell align="center" key={`r-${row.id}`}>
                                <Checkbox checked={row.r} />
                            </TableCell>
                            <TableCell align="center" key={`u-${row.id}`}>
                                <Checkbox checked={row.u} />
                            </TableCell>
                            <TableCell align="center" key={`d-${row.id}`}>
                                <Checkbox checked={row.d} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SystemRoles;
